(() => {
  if (window.cozybeadGiftReady) return;
  window.cozybeadGiftReady = true;
  let opener;
  const modal = () => document.getElementById('cb-gift-details');
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cb-gift-open]');
    if (open) {
      const dialog = modal();
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      opener = open;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('cb-gift-is-open');
    }
    if (event.target.closest('[data-cb-gift-close]')) modal()?.close();
    const dialog = modal();
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  modal()?.addEventListener('close', () => {
    document.documentElement.classList.remove('cb-gift-is-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
})();
